import type { User } from '@appTypes/auth.types';
import type { RouteConfig } from '@appTypes/route.types';
import { hasAnyPermission, hasDeveloperAccess } from '@utils/permissions';

export function canAccessRoute(user: User | null, route: RouteConfig): boolean {
  if (route.public) return true;
  if (!user) return false;
  // Must be checked BEFORE the "no permissions ⇒ allow" fallthrough below,
  // otherwise a developer-only route that declares no permissions would be
  // open to every authenticated user.
  if (route.requiresDeveloper && !hasDeveloperAccess(user)) return false;
  if (!route.permissions || route.permissions.length === 0) return true;
  return hasAnyPermission(user, route.permissions);
}

export function getDefaultRedirect(user: User | null): string {
  if (!user) return '/login';
  return '/';
}

export function filterAccessibleRoutes(user: User | null, routes: RouteConfig[]): RouteConfig[] {
  return routes
    .filter((route) => canAccessRoute(user, route))
    .map((route) => ({
      ...route,
      children: route.children ? filterAccessibleRoutes(user, route.children) : undefined,
    }));
}
